const c = function(e, t) {
    let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    let i, r, f, o = !0;
    const s = function() {
        for(var _len = arguments.length, u = new Array(_len), _key = 0; _key < _len; _key++){
            u[_key] = arguments[_key];
        }
        if (i && clearTimeout(i), o && n.leading) {
            o = !1, e(...u);
            return;
        }
        f = u, !r && n.maxWait && (r = setTimeout(()=>{
            e(...f), r = void 0, clearTimeout(i);
        }, n.maxWait)), i = setTimeout(()=>{
            e(...u), r && clearTimeout(r), i = void 0, r = void 0;
        }, t);
    };
    return s.cancel = ()=>{
        i && (clearTimeout(i), i = void 0), r && (clearTimeout(r), r = void 0);
    }, s;
}, l = (e)=>e === null ? !0 : !(typeof e == "object" || typeof e == "function"), a = (e, t)=>{
    if (e === t) return !0;
    if (l(e) || l(t) || typeof e != typeof t || typeof e == "function") return !1;
    if (Array.isArray(e) || Array.isArray(t)) return Array.isArray(e) && Array.isArray(t) ? e.length === t.length && e.every((r, f)=>a(r, t[f])) : !1;
    if (e instanceof Date || t instanceof Date) return e instanceof Date && t instanceof Date ? e.getTime() === t.getTime() : !1;
    const n = Object.keys(e), i = Object.keys(t);
    return n.length === i.length ? n.every((r)=>a(e[r], t[r])) : !1;
};
export { c as debounce, a as isEqual };
